// Unlock body scroll for all route changes to prevent
// locking the user when a modal is open.
export default ({ app, store }) => {
	if (!process.client) {
		return
	}

	app.router.beforeEach((_, __, next) => {
		// If the modal is open, close it on any navigation
		if (store.state.modal && store.state.modal.visible) {
			store.dispatch('modal/close')
		}

		next()
	})
}
